import { defineWidgetSettings } from "@nexus/widget-sdk";
import { ANIMATE_VALUE_CONFIG } from "@nexus/widget-kit";

/** How long a period stays on show while cycling, in seconds. The host owns the timer. */
export const SPOTLIGHT_INTERVALS = [5, 10, 15, 30] as const;

/** What an author sets on the blocking period spotlight. */
export const settings = defineWidgetSettings({
  id: "blocking-period-spotlight",
  extends: [ANIMATE_VALUE_CONFIG],
  properties: {
    autoplay: {
      type: "boolean",
      title: "Cycle through periods",
      description: "Shows each blocking period in turn. Off keeps the latest period on show.",
      default: true,
      "x-ui": {
        category: "playback",
        order: 10,
        summary: { on: "Cycling", off: "Latest period" },
        resets: ["intervalSeconds"],
      },
    },
    showProgress: {
      type: "boolean",
      title: "Show progress indicator",
      description: "Shows the time until the next period while cycling.",
      default: true,
      "x-ui": { category: "playback", order: 11 },
    },
    intervalSeconds: {
      type: "integer",
      title: "Each period for",
      description: "How long a period stays on show before the next one",
      default: 5,
      oneOf: SPOTLIGHT_INTERVALS.map((seconds) => ({
        const: seconds,
        title: `${seconds} seconds`,
      })),
      "x-ui": { category: "playback", order: 20, summary: true, visibleIf: { autoplay: true } },
    },
    // Which charts highlight the period on show: a link the host keeps between widgets.
    spotlightTargets: {
      type: "string",
      title: "Highlight on charts",
      "x-ui": { category: "playback", order: 30, host: "blockingPeriodSelection.followers" },
    },
  },
});
